import { render } from "./logo.vue?vue&type=template&id=65c2050c&scoped=true"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import "./logo.vue?vue&type=style&index=0&id=65c2050c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65c2050c"

export default script